import { default as axios } from './axiosConfig'
import { getEnv } from '@utils/env'
import type { MedicalCondition } from '@dataTypes/allergy-medical-condition.types'
import { logger } from '@utils/safeLogger'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PATIENT')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export const GetAllMedicalConditions = async (options?: {
  accessToken?: string
  clinicId?: string
}): Promise<MedicalCondition[]> => {
  try {
    const response = await axios.get<
      ApiResponse<{ medical_conditions: MedicalCondition[] }>
    >(`${BUSINESS_LAYER_API}/api/v1/medical-condition`, {
      headers: {
        ...(options?.accessToken
          ? { Authorization: `Bearer ${options.accessToken}` }
          : {}),
        ...(options?.clinicId ? { 'X-Clinic-ID': options.clinicId } : {}),
      },
    })
    return response.data.data.medical_conditions ?? []
  } catch (error) {
    logger.error('Error in GetAllMedicalConditions:', error)
    throw error
  }
}
